/** Narrow unknown router search values to optional strings. */
export function optionalSearchString(value: unknown): string | undefined {
  return typeof value === "string" ? value : undefined;
}

/** Narrow unknown router search values to strings with fallback. */
export function requiredSearchString(value: unknown, fallback = ""): string {
  return typeof value === "string" ? value : fallback;
}

/** Parse a search-param or select value against a type guard, with fallback. */
export function parseEnumValue<T extends string>(
  value: unknown,
  isValid: (candidate: string) => candidate is T,
  fallback: T
): T {
  return typeof value === "string" && isValid(value) ? value : fallback;
}

/** Build a type guard from a readonly tuple of allowed string literals. */
export function enumIncludes<T extends string>(
  allowed: readonly T[]
): (candidate: string) => candidate is T {
  const set = new Set<string>(allowed);
  return (candidate: string): candidate is T => set.has(candidate);
}
